import React, { useEffect, useState } from 'react';
import { Image } from 'antd';
import moment from 'moment/moment.js';
import { useSelector } from 'react-redux';
import Pagination from '../../../components/pagination/Pagination.jsx';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton.jsx';
import columns from '../../../columns/ib/Promotion.js';
import { GetAllPromotionKitApi } from '../../../api/request/ib/ibpromotion.js';
import Copy from '../../../components/copy/Copy.jsx';

export default function PromotionMobile() {
  const { userDetails } = useSelector((state) => state.user);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const copyIframe = (item) => {
    return `<a href="https://client.capitalfxglobal.com/?tab=register&ref=${userDetails.referralCode}">
        <iframe src="http://localhost:3001/promotionKit/${item?.id}?ref=${userDetails.referralCode}" width="${item.width}" height="${item.height}" style="border:none;"></iframe>
    </a>`;
  };

  const getAllpromotion = async () => {
    try {
      setIsLoading(true);
      const params = {
        PageNumber: page,
        PageSize: pageSize,
        FilterText: 'Active',
      };
      const { data } = await GetAllPromotionKitApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          (data?.data || []).map((item) => ({
            ...item,
            url: (
              <div className="h-[50px] w-[50px] overflow-hidden">
                <Image
                  src={item?.url}
                  fallback="/assets/images/promotion-placeholder.png"
                  className="object-cover w-full h-full"
                  alt="img"
                />
              </div>
            ),
            actions: <Copy text={copyIframe(item)} />,
            createdDate: item?.createdDate ? moment(item.createdDate).format('DD-MM-YYYY, hh:mm A') : null,
          }))
        );
        setTotalRecord(data?.totalRecords || 0);
      } else {
        setData([]);
        setTotalRecord(0);
      }
    } catch (error) {
      setData([]);
      setTotalRecord(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllpromotion();
  }, [page, pageSize]);

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
        </div>
      </div>

      <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
    </div>
  );
}
